module.exports = __webpack_public_path__ + "img/icon-company-events.1cd81fae.svg";